export default class {
  static mergeCustomFeatures(navContainer, opts) {
    let url = document.location.toString();
    if (url.match('#')) {
      let hash = `#${url.split('#')[1].replace(/^\/?/i, '')}`;
      $(navContainer).find('a[href="' + hash + '"]').tab('show');
      // this.constructor.updateLinks(opts.updateLinks, hash);
    }

    navContainer.querySelectorAll('.nav a:not(.anchor)').forEach((a) => {
      a.addEventListener('click', (ev) => {
        ev.preventDefault();
        window.location.hash = a.attributes.href.value;
        // this.constructor.updateLinks(opts.updateLinks, a.attributes.href.value);
      });
    });

    let wrapper = navContainer.closest('.tr-nav') || navContainer.closest('form'),
      navTabs = navContainer.querySelector('.nav-tabs');

    wrapper.querySelectorAll('[data-nav-arrow]').forEach((arrow) => {
      arrow.addEventListener('click', (ev) => {
        ev.preventDefault();
        const event = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        });

        try {
          let isNext = arrow.dataset.navArrow === 'next' || arrow.dataset.navArrow === 'forward',
            lis = navTabs.querySelectorAll('li'),
            currentIndex = [...lis].indexOf(navTabs.querySelector('li.active')),
            tab = isNext ? lis[currentIndex + 1] : lis[currentIndex - 1];

          tab && tab.querySelector('a').dispatchEvent(event)
        } catch (ex) {
          console.log('tab not found');
        }
      });
    });
  }

  static updateLinks(links, hash) {
    document.querySelectorAll(links).forEach((link) => {
      let href = link.getAttribute('href');
      if (!href)
        return;

      link.setAttribute('href', `${href.replaceAll(/\#.*$/ig, '')}${hash}`);
    });
  }
}